import { api } from "../ConsumeApiController";
import CustomerRoutes from "../../apiRoutes/CustomerRoutes";
/**
 * --------------------------------------------------------------------------
 * CREATE MARKETPLACE ORDERS
 * --------------------------------------------------------------------------
 * Envía la información de envío y el UUID del carrito para convertirlo
 * en pedidos reales (estatus: pending_payment).
 * * @param {object} checkoutData { shipping_address, cart_uuid, payment_method }
 */
export const createMarketplaceOrders = async (checkoutData) => {
    try {
        // Endpoint que definimos en el Backend (CheckoutController@process)
        const response = await api.post(CustomerRoutes.Commerce.Cart.Checkout, checkoutData);
        
        // Retornamos la respuesta tal cual viene del backend.
        // Esperamos: { success: true, data: { orders: [], total_to_pay: 0, reference: '' } }
        return response; 
    } catch (error) {
        console.error("Error creating orders:", error);
        return { 
            success: false, 
            message: error.response?.data?.message || 'Error de conexión al generar los pedidos.' 
        };
    }
};